<div class="modal fade" id="verifyInformationModal" tabindex="-1" role="dialog" aria-labelledby="verifyInformationModal"
    aria-hidden="true" data-keyboard="false" data-backdrop="static">

    <div class="modal-dialog modal-dialog-centered modal-lg w750" role="document">
        <div class="component-container modal-content clearfix">
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <img src="/assets/images/icons/close_b.svg" alt="close b" />
                    CLOSE WINDOW
                </button>
            </div>
            <div class="modal-body">
                <div class="text-center information-box-title">
                    <h1>Please Verify Your Information</h1>
                </div>

                <div class="information-content">
                    <form class="information-box" *ngIf="!isSole" [formGroup]="businessInfo.form">
                        <div class="d-flex justify-content-between information-box-header"
                            [ngClass]="!isEditBusiness ? 'border-bottom-custom' : 'border-0'">
                            <div>
                                <div class="font-mont-semi-bold form-step-number">1</div>
                                <div class="form-step-title ">
                                    <h1 class="font-mont-semi-bold">Business Information</h1>
                                </div>
                            </div>
                            <span class="btn-edit" [ngClass]="isEditBusiness ? 'red-text' : 'btn-edit'"
                                (click)="onEditForm('isEditBusiness')">Edit</span>
                        </div>

                        <div class="d-flex justify-content-between information-box-content"
                            [ngClass]="isEditBusiness ? 'border-bottom-custom' : 'border-0'">
                            <span for="legalCompanyName">Business Name</span>
                            <span
                                *ngIf="!isEditBusiness">{{businessInfoForm.form.controls.legalCompanyName.value}}</span>
                            <input *ngIf="isEditBusiness" type="text" formControlName="legalCompanyName"
                                id="legalCompanyName" name="legalCompanyName"
                                value="{{businessInfo.form.controls.legalCompanyName.value}}">
                        </div>

                        <div class="d-flex justify-content-between information-box-content bsDatepicker"
                            [ngClass]="isEditBusiness ? 'border-bottom-custom' : 'border-0'">
                            <span for="businessStartDate">Business Start Date*</span>
                            <span *ngIf="!isEditBusiness">{{businessInfoForm.form.controls.businessStartDate.value |
                                date:'MM/yyyy'}}</span>

                            <input *ngIf="isEditBusiness"
                                value="{{businessInfo.form.controls.businessStartDate.value | date:'MM/yyyy'}}"
                                placeholder="mm/yyyy" type="text" formControlName="businessStartDate"
                                id="businessStartDate" name="businessStartDate"
                                [ngClass]="{ 'is-invalid': submitted && businessInfo.form.controls.businessStartDate.errors }"
                                bsDatepicker
                                [bsConfig]="{ dateInputFormat: 'MM/YYYY', isAnimated: true, containerClass: 'theme-dark-blue', minMode: 'month'}"
                                [maxDate]="today" maxlength="6">
                        </div>

                        <div class="d-flex justify-content-between information-box-content"
                            [ngClass]="isEditBusiness ? 'border-bottom-custom' : 'border-0'">
                            <span for="primaryContactEmail">Business Email*</span>
                            <span
                                *ngIf="!isEditBusiness">{{businessInfoForm.form.controls.primaryContactEmail.value}}</span>

                            <input *ngIf="isEditBusiness" type="email" formControlName="primaryContactEmail"
                                id="primaryContactEmail" name="primaryContactEmail"
                                value="{{businessInfoForm.form.controls.primaryContactEmail.value}}"
                                [ngClass]="{ 'is-invalid': submitted && businessInfoForm.form.controls.primaryContactEmail.errors }">
                        </div>

                        <div class="d-flex justify-content-between information-box-content"
                            [ngClass]="isEditBusiness ? 'border-bottom-custom' : 'border-0'">
                            <span>Doing Business As (DBA)</span>
                            <span
                                *ngIf="!isEditBusiness">{{businessInfoForm.form.controls.doingBusinessAs.value}}</span>

                            <input *ngIf="isEditBusiness" type="text" formControlName="doingBusinessAs"
                                id="doingBusinessAs" name="doingBusinessAs"
                                [ngClass]="{ 'is-invalid': submitted && businessInfo.form.controls.doingBusinessAs.errors }">


                        </div>

                        <div class="d-flex justify-content-between information-box-content"
                            [ngClass]="isEditBusiness ? 'border-bottom-custom' : 'border-0'">
                            <span>Business Street Address</span>
                            <span
                                *ngIf="!isEditBusiness">{{businessInfoForm.form.controls.businessAddress.value}}</span>

                            <input *ngIf="isEditBusiness" type="text" formControlName="businessAddress"
                                id="businessAddress" name="businessAddress"
                                [ngClass]="{ 'is-invalid': submitted && businessInfo.form.controls.businessAddress.errors }">
                        </div>

                        <div class="d-flex justify-content-between information-box-content"
                            [ngClass]="isEditBusiness ? 'border-bottom-custom' : 'border-0'">
                            <span>City</span>
                            <span *ngIf="!isEditBusiness">{{businessInfoForm.form.controls.city.value}}</span>

                            <select formControlName="city" *ngIf="isEditBusiness" id="city"
                                [ngClass]="{ 'is-invalid': submitted && businessInfo.form.controls.city.errors }">
                                <option *ngFor="let city of businessInfoCities" [ngValue]="city">{{city}}</option>
                            </select>
                        </div>

                        <div class="d-flex justify-content-between information-box-content box-50 box-50-calc"
                            [ngClass]="isEditBusiness ? 'border-bottom-custom' : 'border-0'">
                            <span>Zip*</span>
                            <span *ngIf="!isEditBusiness">{{businessInfoForm.form.controls.zip.value}}</span>


                            <input *ngIf="isEditBusiness" type="text" formControlName="zip" id="zip" name="zip"
                                (keyup)="onZipCodeKeyUpHandler('businessInfo')" maxlength="5" pattern="\d*"
                                [ngClass]="{ 'is-invalid': submitted && businessInfo.form.controls.zip.errors }">

                        </div>

                        <div class="d-flex justify-content-between information-box-content box-50 box-50-second"
                            [ngClass]="isEditBusiness ? 'border-bottom-custom' : 'border-0'">
                            <span>County*</span>
                            <span *ngIf="!isEditBusiness">{{businessInfoForm.form.controls.county.value}}</span>

                            <select *ngIf="isEditBusiness" formControlName="county" id="county"
                                [ngClass]="{ 'is-invalid': submitted && businessInfo.form.controls.county.errors }">
                                <option *ngFor="let county of businessInfoCounties" [ngValue]="county">{{county}}
                                </option>
                            </select>
                        </div>

                        <div class="d-flex justify-content-between information-box-content"
                            [ngClass]="isEditBusiness ? 'border-bottom-custom' : 'border-0'">
                            <span>State*</span>
                            <span *ngIf="!isEditBusiness">{{businessInfoForm.form.controls.state.value}}</span>
                            <select *ngIf="isEditBusiness" formControlName="state" id="state"
                                [ngClass]="{ 'is-invalid': submitted && businessInfo.form.controls.state.errors }"
                                [attr.disabled]="true">
                                <option *ngFor="let state of businessInfoStates" [ngValue]="state.code">
                                    {{state.name}}</option>
                            </select>
                        </div>

                        <div class="d-flex justify-content-between information-box-content"
                            [ngClass]="isEditBusiness ? 'border-bottom-custom' : 'border-0'">
                            <span>Requested Amount*</span>
                            <span *ngIf="!isEditBusiness">{{businessInfoForm.form.controls.requestedAmount.value |
                                currency:'$ ':'code':'.0-0'}}</span>

                            <input *ngIf="isEditBusiness" type="text" formControlName="requestedAmount"
                                id="requestedAmount" placeholder="$ " name="requestedAmount" prefix="$ "
                                mask="separator.2" thousandSeparator=","
                                value="{{businessInfo.form.controls.requestedAmount.value}}"
                                [ngClass]="{ 'is-invalid': submitted && businessInfoForm.form.controls.requestedAmount.errors }">
                        </div>

                        <div class="d-flex justify-content-between information-box-content"
                            [ngClass]="isEditBusiness ? 'border-bottom-custom' : 'border-0'">
                            <span>Equipment Description</span>
                            <span
                                *ngIf="!isEditBusiness">{{businessInfoForm.form.controls.equipmentDescription.value}}</span>

                            <input *ngIf="isEditBusiness" type="text" formControlName="equipmentDescription"
                                id="equipmentDescription" name="equipmentDescription"
                                value="{{businessInfo.form.controls.equipmentDescription.value}}"
                                [ngClass]="{ 'is-invalid': submitted && businessInfo.form.controls.equipmentDescription.errors }" />
                        </div>

                        <div class="d-flex justify-content-center" *ngIf="isEditBusiness">
                            <button type="submit" class="btn btn-primary btn-lg round-button font-mont-regular"
                                (click)="onDone('isEditBusiness')" [disabled]="businessInfo.form.invalid "> DONE
                            </button>
                        </div>
                    </form>

                    <form class="information-box" [formGroup]="ownersInfo.form" *ngIf="!isSole">
                        <div class="d-flex justify-content-between information-box-header"
                            [ngClass]="!isEditOwner ? 'border-bottom-custom' : 'border-0'">
                            <div class="">
                                <div class="font-mont-semi-bold form-step-number">2</div>
                                <div class="form-step-title">
                                    <h1 class="font-mont-semi-bold">Owner Information</h1>
                                </div>
                            </div>

                            <span class="btn-edit" [ngClass]="isEditOwner ? 'red-text' : 'btn-edit'"
                                (click)="onEditForm('isEditOwner')">Edit</span>
                        </div>

                        <div class="d-flex justify-content-between information-box-content"
                            [ngClass]="isEditOwner ? 'border-bottom-custom' : 'border-0'">
                            <span for="firstName">First name*</span>
                            <span *ngIf="!isEditOwner">{{ownersInfoForm.form.controls.firstName.value}}</span>

                            <input *ngIf="isEditOwner" type="text" formControlName="firstName" id="firstName"
                                name="firstName" value="{{ownersInfo.form.controls.firstName.value}}"
                                [ngClass]="{ 'is-invalid': submitted && ownersInfo.form.firstName.errors }">
                        </div>

                        <div class="d-flex justify-content-between information-box-content"
                            [ngClass]="isEditOwner ? 'border-bottom-custom' : 'border-0'">
                            <span>Last name*</span>
                            <span *ngIf="!isEditOwner">{{ownersInfoForm.form.controls.lastName.value}}</span>
                            <input *ngIf="isEditOwner" type="text" formControlName="lastName" id="lastName"
                                value="{{ownersInfo.form.controls.lastName.value}}" name="lastName"
                                [ngClass]="{ 'is-invalid': submitted && ownersInfo.form.controls.lastName.errors }">
                        </div>

                        <div class="d-flex justify-content-between information-box-content"
                            [ngClass]="isEditOwner ? 'border-bottom-custom' : 'border-0'">
                            <span>Date of birth*</span>
                            <span *ngIf="!isEditOwner">{{ownersInfoForm.form.controls.birthDate.value |
                                date:'MM/dd/yyyy'}}</span>
                            <input *ngIf="isEditOwner" type="text" formControlName="birthDate" id="birthDate"
                                name="birthDate"
                                [ngClass]="{ 'is-invalid': submitted && ownersInfo.form.controls.birthDate.errors }"
                                bsDatepicker maxlength="8" [maxDate]="today" value="{{ownersInfo.form.controls.birthDate.value |
                                    date:'MM/dd/yyyy'}}"
                                [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY', isAnimated: true, containerClass: 'theme-dark-blue' }">
                        </div>

                        <div class="d-flex justify-content-between information-box-content"
                            [ngClass]="isEditOwner ? 'border-bottom-custom' : 'border-0'">
                            <span>Social Security number*</span>
                            <span *ngIf="!isEditOwner">{{ownersInfoForm.form.controls.socialSecurityNumber.value | mask:
                                '000-00-0000'}}</span>

                            <input *ngIf="isEditOwner" type="text" formControlName="socialSecurityNumber"
                                id="socialSecurityNumber" name="socialSecurityNumber" [showMaskTyped]="true"
                                mask="000-00-0000" value="{{ownersInfo.form.controls.socialSecurityNumber.value}}"
                                [ngClass]="{ 'is-invalid': submitted && ownersInfo.form.controls.socialSecurityNumber.errors }">
                        </div>

                        <div class="d-flex justify-content-between information-box-content"
                            [ngClass]="isEditOwner ? 'border-bottom-custom' : 'border-0'">
                            <span>Mobile phone*</span>
                            <span *ngIf="!isEditOwner">{{ownersInfoForm.form.controls.mobilePhoneNumber.value | mask:
                                '(000) 000-0000'}}</span>

                            <input *ngIf="isEditOwner" type="text" formControlName="mobilePhoneNumber"
                                id="smobilePhoneNumber" placeholder="Home Phone Number" name="mobilePhoneNumber"
                                [showMaskTyped]="true" mask="(000) 000-0000"
                                value="{{ownersInfo.form.controls.mobilePhoneNumber.value}}"
                                [ngClass]="{ 'is-invalid': submitted && ownersInfo.form.controls.mobilePhoneNumber.errors }">
                        </div>

                        <div class="d-flex justify-content-between information-box-content"
                            [ngClass]="isEditOwner ? 'border-bottom-custom' : 'border-0'">
                            <span>Owner Percentage*</span>
                            <span *ngIf="!isEditOwner">
                                {{ownersInfoForm.form.controls.ownershipPercentage.value}}%
                            </span>
                            <input *ngIf="isEditOwner" type="text" formControlName="ownershipPercentage"
                                id="ownershipPercentage" name="ownershipPercentage"
                                [ngClass]="{ 'is-invalid': submitted && ownersInfo.form.controls.ownershipPercentage.errors }"
                                mask="percent" suffix=" %"
                                value="{{ownersInfo.form.controls.ownershipPercentage.value}}">
                        </div>


                        <div class="d-flex justify-content-between information-box-content"
                            [ngClass]="isEditOwner ? 'border-bottom-custom' : 'border-0'">
                            <span>Home Address*</span>
                            <span *ngIf="!isEditOwner">{{ownersInfoForm.form.controls.homeAddress.value}}</span>

                            <input *ngIf="isEditOwner" type="text" formControlName="homeAddress" id="shomeAddress"
                                name="homeAddress" value="{{ownersInfo.form.controls.homeAddress.value}}"
                                [ngClass]="{ 'is-invalid': submitted && ownersInfo.form.controls.homeAddress.errors }">
                        </div>

                        <div class="d-flex justify-content-between information-box-content box-50 box-50-calc"
                            [ngClass]="isEditOwner ? 'border-bottom-custom' : 'border-0'">
                            <span>Zip*</span>
                            <span *ngIf="!isEditOwner">{{ownersInfoForm.form.controls.zipCode.value}}</span>

                            <input *ngIf="isEditOwner" type="text" formControlName="zipCode" id="szipCode"
                                name="zipCode" (keyup)="onZipCodeKeyUpHandler('ownersInfo')"
                                [ngClass]="{ 'is-invalid': submitted && ownersInfo.form.controls.zipCode.errors }">
                        </div>

                        <div class="d-flex justify-content-between information-box-content box-50 box-50-second"
                            [ngClass]="isEditOwner ? 'border-bottom-custom' : 'border-0'">
                            <span>City</span>
                            <span *ngIf="!isEditOwner">{{ownersInfoForm.form.controls.city.value}}</span>
                            <select *ngIf="isEditOwner" formControlName="city" id="scity"
                                [ngClass]="{ 'is-invalid': submitted && ownersInfo.form.controls.city.errors }">
                                <option *ngFor="let city of ownersInfoCities" [ngValue]="city">{{city}}</option>
                            </select>
                        </div>

                        <div class="d-flex justify-content-between information-box-content"
                            [ngClass]="isEditOwner ? 'border-bottom-custom' : 'border-0'">
                            <span>State*</span>
                            <span *ngIf="!isEditOwner">{{ownersInfoForm.form.controls.state.value}}</span>

                            <select *ngIf="isEditOwner" formControlName="state" id="state"
                                [ngClass]="{ 'is-invalid': submitted && ownersInfo.form.controls.state.errors }"
                                [attr.disabled]="true">
                                <option *ngFor="let state of ownersInfoStates" [ngValue]="state.code">{{state.name}}
                                </option>
                            </select>
                        </div>

                        <div class="d-flex justify-content-center" *ngIf="isEditOwner">
                            <button type="submit" class="btn btn-primary btn-lg round-button font-mont-regular"
                                (click)="onDone('isEditOwner')" [disabled]="ownersInfo.form.invalid "> DONE
                            </button>
                        </div>
                    </form>


                    <!-- Sole  -->

                    <form class="information-box" [formGroup]="soleOwnersInfo.form" *ngIf="isSole">
                        <div class="d-flex justify-content-between information-box-header"
                            [ngClass]="!isSoleOwners ? 'border-bottom-custom' : 'border-0'">
                            <div class="">
                                <div class="font-mont-semi-bold form-step-number">2</div>
                                <div class="form-step-title">
                                    <h1 class="font-mont-semi-bold">Owner Information</h1>
                                </div>
                            </div>

                            <span class="btn-edit" [ngClass]="isSoleOwners ? 'red-text' : 'btn-edit'"
                                (click)="onEditForm('isSoleOwners')">Edit</span>
                        </div>

                        <div class="d-flex justify-content-between information-box-content"
                            [ngClass]="isSoleOwners ? 'border-bottom-custom' : 'border-0'">
                            <span for="firstName">First name*</span>
                            <span *ngIf="!isSoleOwners">{{soleOwnersInfoForm.form.controls.firstName.value}}</span>

                            <input *ngIf="isSoleOwners" type="text" formControlName="firstName" id="firstName"
                                name="firstName" value="{{soleOwnersInfo.form.controls.firstName.value}}"
                                [ngClass]="{ 'is-invalid': submitted && soleOwnersInfo.form.firstName.errors }">
                        </div>

                        <div class="d-flex justify-content-between information-box-content"
                            [ngClass]="isSoleOwners ? 'border-bottom-custom' : 'border-0'">
                            <span>Last name*</span>
                            <span *ngIf="!isSoleOwners">{{soleOwnersInfoForm.form.controls.lastName.value}}</span>
                            <input *ngIf="isSoleOwners" type="text" formControlName="lastName" id="lastName"
                                value="{{soleOwnersInfo.form.controls.lastName.value}}" name="lastName"
                                [ngClass]="{ 'is-invalid': submitted && soleOwnersInfo.form.controls.lastName.errors }">
                        </div>

                        <div class="d-flex justify-content-between information-box-content"
                            [ngClass]="isSoleOwners ? 'border-bottom-custom' : 'border-0'">
                            <span>Email Address*</span>
                            <span *ngIf="!isSoleOwners">{{soleOwnersInfoForm.form.controls.emailAddress.value}}</span>
                            <input *ngIf="isSoleOwners" type="email" formControlName="emailAddress" id="emailAddress"
                                name="emailAddress" value="{{soleOwnersInfo.form.controls.emailAddress.value}}"
                                [ngClass]="{ 'is-invalid': submitted && soleOwnersInfo.form.controls.emailAddress.errors }">
                        </div>


                        <div class="d-flex justify-content-between information-box-content"
                            [ngClass]="isSoleOwners ? 'border-bottom-custom' : 'border-0'">
                            <span>Date of birth*</span>
                            <span *ngIf="!isSoleOwners">{{soleOwnersInfoForm.form.controls.birthDate.value |
                                date:'MM/dd/yyyy'}}</span>
                            <input *ngIf="isSoleOwners" type="text" formControlName="birthDate" id="birthDate"
                                name="birthDate"
                                [ngClass]="{ 'is-invalid': submitted && soleOwnersInfo.form.controls.birthDate.errors }"
                                bsDatepicker maxlength="8" [maxDate]="today" value="{{soleOwnersInfo.form.controls.birthDate.value |
                                    date:'MM/dd/yyyy'}}"
                                [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY', isAnimated: true, containerClass: 'theme-dark-blue' }">
                        </div>

                        <div class="d-flex justify-content-between information-box-content"
                            [ngClass]="isSoleOwners ? 'border-bottom-custom' : 'border-0'">
                            <span>Social Security number*</span>
                            <span *ngIf="!isSoleOwners">{{soleOwnersInfoForm.form.controls.socialSecurityNumber.value |
                                mask: '000-00-0000'}}</span>

                            <input *ngIf="isSoleOwners" type="text" formControlName="socialSecurityNumber"
                                id="socialSecurityNumber" name="socialSecurityNumber" [showMaskTyped]="true"
                                mask="000-00-0000" value="{{soleOwnersInfo.form.controls.socialSecurityNumber.value}}"
                                [ngClass]="{ 'is-invalid': submitted && soleOwnersInfo.form.controls.socialSecurityNumber.errors }">
                        </div>

                        <div class="d-flex justify-content-between information-box-content"
                            [ngClass]="isSoleOwners ? 'border-bottom-custom' : 'border-0'">
                            <span>Mobile phone*</span>
                            <span *ngIf="!isSoleOwners">{{soleOwnersInfoForm.form.controls.mobilePhoneNumber.value |
                                mask: '(000) 000-0000'}}</span>

                            <input *ngIf="isSoleOwners" type="text" formControlName="mobilePhoneNumber"
                                id="smobilePhoneNumber" placeholder="Home Phone Number" name="mobilePhoneNumber"
                                [showMaskTyped]="true" mask="(000) 000-0000"
                                value="{{soleOwnersInfo.form.controls.mobilePhoneNumber.value}}"
                                [ngClass]="{ 'is-invalid': submitted && soleOwnersInfo.form.controls.mobilePhoneNumber.errors }">
                        </div>

                        <div class="d-flex justify-content-between information-box-content"
                            [ngClass]="isSoleOwners ? 'border-bottom-custom' : 'border-0'">
                            <span>Business Name / Trade / DBA*</span>
                            <span
                                *ngIf="!isSoleOwners">{{soleOwnersInfoForm.form.controls.doingBusinessAs.value}}</span>

                            <input *ngIf="isSoleOwners" type="text" formControlName="doingBusinessAs"
                                id="sdoingBusinessAs" name="doingBusinessAs"
                                [ngClass]="{ 'is-invalid': submitted && soleOwnersInfo.form.controls.doingBusinessAs.errors }">
                        </div>

                        <div class="d-flex justify-content-between information-box-content"
                            [ngClass]="isSoleOwners ? 'border-bottom-custom' : 'border-0'">
                            <span>Business Start Date*</span>
                            <span *ngIf="!isSoleOwners">{{soleOwnersInfoForm.form.controls.businessStartDate.value |
                                date:'MM/yyyy'}}</span>
                            <input *ngIf="isSoleOwners"
                                value="{{soleOwnersInfo.form.controls.businessStartDate.value | date:'MM/yyyy'}}"
                                placeholder="mm/yyyy" type="text" formControlName="businessStartDate"
                                id="businessStartDate" name="businessStartDate"
                                [ngClass]="{ 'is-invalid': submitted && soleOwnersInfo.form.controls.businessStartDate.errors }"
                                bsDatepicker
                                [bsConfig]="{ dateInputFormat: 'MM/YYYY', isAnimated: true, containerClass: 'theme-dark-blue', minMode: 'month'}"
                                [maxDate]="today" maxlength="6">
                        </div>

                        <div class="d-flex justify-content-between information-box-content"
                            [ngClass]="isSoleOwners ? 'border-bottom-custom' : 'border-0'">
                            <span>Home Address*</span>
                            <span *ngIf="!isSoleOwners">{{soleOwnersInfoForm.form.controls.homeAddress.value}}</span>

                            <input *ngIf="isSoleOwners" type="text" formControlName="homeAddress" id="shomeAddress"
                                name="homeAddress" value="{{soleOwnersInfo.form.controls.homeAddress.value}}"
                                [ngClass]="{ 'is-invalid': submitted && soleOwnersInfo.form.controls.homeAddress.errors }">
                        </div>
                        <div class="d-flex justify-content-between information-box-content"
                            [ngClass]="isSoleOwners ? 'border-bottom-custom' : 'border-0'">
                            <span>City</span>
                            <span *ngIf="!isSoleOwners">{{soleOwnersInfoForm.form.controls.city.value}}</span>
                            <select *ngIf="isSoleOwners" formControlName="city" id="scity"
                                [ngClass]="{ 'is-invalid': submitted && soleOwnersInfo.form.controls.city.errors }">
                                <option *ngFor="let city of soleOwnersInfoCities" [ngValue]="city">{{city}}</option>
                            </select>
                        </div>
                        <div class="d-flex justify-content-between information-box-content box-50 box-50-calc"
                            [ngClass]="isSoleOwners ? 'border-bottom-custom' : 'border-0'">
                            <span>Zip*</span>
                            <span *ngIf="!isSoleOwners">{{soleOwnersInfoForm.form.controls.zipCode.value}}</span>

                            <input *ngIf="isSoleOwners" type="text" formControlName="zipCode" id="szipCode"
                                name="zipCode" (keyup)="onZipCodeKeyUpHandler('soleOwnersInfo')"
                                [ngClass]="{ 'is-invalid': submitted && soleOwnersInfo.form.controls.zipCode.errors }">
                        </div>

                        <div class="d-flex justify-content-between information-box-content box-50 box-50-second"
                            [ngClass]="isSoleOwners ? 'border-bottom-custom' : 'border-0'">
                            <span>County*</span>
                            <span *ngIf="!isSoleOwners">{{soleOwnersInfoForm.form.controls.county.value}}</span>
                            <select *ngIf="isSoleOwners" formControlName="county" id="scounty"
                                [ngClass]="{ 'is-invalid': submitted && soleOwnersInfo.form.controls.county.errors }">
                                <option *ngFor="let county of soleOwnersInfoCounties" [ngValue]="county">{{county}}
                                </option>
                            </select>

                        </div>

                        <div class="d-flex justify-content-between information-box-content"
                            [ngClass]="isSoleOwners ? 'border-bottom-custom' : 'border-0'">
                            <span>State*</span>
                            <span *ngIf="!isSoleOwners">{{soleOwnersInfoForm.form.controls.state.value}}</span>

                            <select *ngIf="isSoleOwners" formControlName="state" id="state"
                                [ngClass]="{ 'is-invalid': submitted && soleOwnersInfo.form.controls.state.errors }"
                                [attr.disabled]="true">
                                <option *ngFor="let state of soleOwnersInfoStates" [ngValue]="state.code">{{state.name}}
                                </option>
                            </select>
                        </div>
                        <div class="d-flex justify-content-between information-box-content"
                            [ngClass]="isSoleOwners ? 'border-bottom-custom' : 'border-0'"
                            [ngStyle]="{'margin-top.px': soleOwnersInfoForm.form.controls.sameAsBusiness.value === 'true' ? 0 : 20}">
                            <span>Business address same as Home address?</span>
                            <span *ngIf="!isSoleOwners">
                                {{soleOwnersInfoForm.form.controls.sameAsBusiness.value === 'true' ? 'Yes': 'No'}}
                            </span>
                            <div *ngIf="isSoleOwners" class="sameAsBusiness-form">
                                <input type="radio" id="same-as-home-yes" value="true"
                                    [formControl]="soleOwnersInfo.form.controls.sameAsBusiness" name="sameAsBusiness">
                                <label for="same-as-home-yes">Yes</label>
                                <input type="radio" id="same-as-home-no" value="false"
                                    [formControl]="soleOwnersInfo.form.controls.sameAsBusiness" name="sameAsBusiness">
                                <label for="same-as-home-no">No</label>
                            </div>
                        </div>
                        <div class="d-flex justify-content-between information-box-content"
                            *ngIf="soleOwnersInfoForm.form.controls.sameAsBusiness.value !== 'true'"
                            [ngClass]="isSoleOwners ? 'border-bottom-custom' : 'border-0'">
                            <span>Business Street Address*</span>
                            <span
                                *ngIf="!isSoleOwners">{{soleOwnersInfoForm.form.controls.businessAddress.value}}</span>
                        </div>
                        <div class="d-flex justify-content-between information-box-content"
                            *ngIf="soleOwnersInfoForm.form.controls.sameAsBusiness.value !== 'true'"
                            [ngClass]="isSoleOwners ? 'border-bottom-custom' : 'border-0'">
                            <span>City</span>
                            <span *ngIf="!isSoleOwners">{{soleOwnersInfoForm.form.controls.businessCity.value}}</span>
                        </div>
                        <div class="d-flex justify-content-between information-box-content box-50 box-50-calc"
                            *ngIf="soleOwnersInfoForm.form.controls.sameAsBusiness.value !== 'true'"
                            [ngClass]="isSoleOwners ? 'border-bottom-custom' : 'border-0'">
                            <span>Zip*</span>
                            <span *ngIf="!isSoleOwners">{{soleOwnersInfoForm.form.controls.businessZip.value}}</span>
                        </div>
                        <div class="d-flex justify-content-between information-box-content box-50 box-50-second"
                            *ngIf="soleOwnersInfoForm.form.controls.sameAsBusiness.value !== 'true'"
                            [ngClass]="isSoleOwners ? 'border-bottom-custom' : 'border-0'">
                            <span>County*</span>
                            <span *ngIf="!isSoleOwners">{{soleOwnersInfoForm.form.controls.businessCounty.value}}</span>
                        </div>
                        <div class="d-flex justify-content-between information-box-content"
                            *ngIf="soleOwnersInfoForm.form.controls.sameAsBusiness.value !== 'true'"
                            [ngClass]="isSoleOwners ? 'border-bottom-custom' : 'border-0'">
                            <span>State*</span>
                            <span *ngIf="!isSoleOwners">{{soleOwnersInfoForm.form.controls.businessState.value}}</span>
                        </div>
                        <div class="d-flex justify-content-between information-box-header">
                            <div class="form-step-title">
                                <h1 class="font-mont-semi-bold font-16">Equipment Information</h1>
                            </div>
                        </div>
                        <div class="d-flex justify-content-between information-box-content"
                            [ngClass]="isSoleOwners ? 'border-bottom-custom' : 'border-0'">
                            <span>Requested Amount *</span>
                            <span *ngIf="!isSoleOwners">{{soleOwnersInfoForm.form.controls.requestedAmount.value |
                                currency:'$ ':'code':'.0-0'}}</span>

                            <input *ngIf="isSoleOwners" type="text" formControlName="requestedAmount"
                                id="srequestedAmount" placeholder="$ " name="requestedAmount" prefix="$ "
                                mask="separator.2" thousandSeparator=","
                                value="{{soleOwnersInfo.form.controls.requestedAmount.value}}"
                                [ngClass]="{ 'is-invalid': submitted && soleOwnersInfo.form.controls.requestedAmount.errors }">
                        </div>
                        <div class="d-flex justify-content-between information-box-content"
                            [ngClass]="isSoleOwners ? 'border-bottom-custom' : 'border-0'">
                            <span>Equipment Description</span>
                            <span
                                *ngIf="!isSoleOwners">{{soleOwnersInfoForm.form.controls.equipmentDescription.value}}</span>
                            <input *ngIf="isSoleOwners" type="text" formControlName="equipmentDescription"
                                id="sequipmentDescription" name="equipmentDescription"
                                value="{{soleOwnersInfo.form.controls.equipmentDescription.value}}"
                                [ngClass]="{ 'is-invalid': submitted && soleOwnersInfo.form.controls.equipmentDescription.errors }" />
                        </div>

                        <div class="d-flex justify-content-center" *ngIf="isSoleOwners">
                            <button type="submit" class="btn btn-primary btn-lg round-button font-mont-regular"
                                (click)="onDone('isSoleOwners')"> DONE
                            </button>
                        </div>
                    </form>
                </div>

                <footer>
                    <div class="form-row justify-content-center ">
                        <div #verifyInformationRecaptcha id="verifyInformationRecaptcha" class="recaptcha-container">
                        </div>
                        <div class="text-center w-100">
                            <button type="submit" (click)="onContinueClick()" [disabled]="buttonContinueDisabled"
                                class="btn btn-primary btn-lg round-button font-mont-regular">SUBMIT</button>
                        </div>
                    </div>
                </footer>
            </div>
        </div>
    </div>
</div>